var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.000000 0.000000 96.000000 96.000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_Bike",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 15.5,
    r: 8,
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#404040",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 23.000000 54.500000 C 13.600000 54.500000 6.000000 62.099998 6.000000 71.500000 C 6.000000 80.900002 13.600000 88.500000 23.000000 88.500000 C 32.400002 88.500000 40.000000 80.900002 40.000000 71.500000 C 40.000000 62.099998 32.400002 54.500000 23.000000 54.500000 Z M 23.000000 84.500000 C 15.800000 84.500000 10.000000 78.699997 10.000000 71.500000 C 10.000000 64.300003 15.800000 58.500000 23.000000 58.500000 C 30.200001 58.500000 36.000000 64.300003 36.000000 71.500000 C 36.000000 78.699997 30.200001 84.500000 23.000000 84.500000 Z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#404040",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 73.000000 54.500000 C 63.599998 54.500000 56.000000 62.099998 56.000000 71.500000 C 56.000000 80.900002 63.599998 88.500000 73.000000 88.500000 C 82.400002 88.500000 90.000000 80.900002 90.000000 71.500000 C 90.000000 62.099998 82.400002 54.500000 73.000000 54.500000 Z M 73.000000 84.500000 C 65.800003 84.500000 60.000000 78.699997 60.000000 71.500000 C 60.000000 64.300003 65.800003 58.500000 73.000000 58.500000 C 80.199997 58.500000 86.000000 64.300003 86.000000 71.500000 C 86.000000 78.699997 80.199997 84.500000 73.000000 84.500000 Z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#404040",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 55.700001 39.799999 C 56.500000 40.599998 57.500000 41.000000 58.500000 41.000000 L 70.000000 41.000000 C 72.199997 41.000000 74.000000 39.200001 74.000000 37.000000 C 74.000000 34.799999 72.199997 33.000000 70.000000 33.000000 L 60.200001 33.000000 C 60.200001 33.000000 48.799999 21.500000 48.599998 21.400000 C 46.099998 19.200001 42.299999 19.500000 40.099998 22.000000 L 26.500000 37.500000 C 24.299999 40.000000 24.600000 43.799999 27.000000 46.000000 C 27.600000 46.500000 28.200001 46.900002 28.900000 47.099998 L 28.900000 47.099998 L 43.900002 53.099998 L 43.900002 71.400002 C 43.900002 73.599998 45.700001 75.400002 47.900002 75.400002 C 50.099998 75.400002 51.900002 73.599998 51.900002 71.400002 L 51.900002 50.400002 C 51.900002 48.799999 50.900002 47.299999 49.500000 46.700001 L 38.400002 42.000000 L 47.500000 31.600000 L 55.700001 39.799999 Z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#404040",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/Bicycle.90f519ae46fd0d76195e6a0ee1fd29c3.svg";
export { ForwardRef as ReactComponent };